var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 9.5 11",
    style: {
      enableBackground: "new 0 0 9.5 11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#6F7275;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sort Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List-Elements---Tiles_x2C_-Tables_x2C_-Tree"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fundamental_Modular_UI_List-Element_Table_Fixable-Column",
    transform: "translate(-148.000000, -2444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Copy-4",
    transform: "translate(71.000000, 2302.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow-down",
    className: "st0",
    d: "M81.7,142l4.7,4.8H77L81.7,142z M81.7,143l-3.1,3.1h6.2L81.7,143z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arrow-up",
    className: "st0",
    d: "M81.7,153l-4.7-4.8h9.4L81.7,153z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.e4329fdc.svg";
export { ForwardRef as ReactComponent };